import { ConfigService } from 'app/Core/Abstract/config.service';
import {  Component, OnInit, ViewChild,ViewChildren,QueryList} from "@angular/core";
import { DecimalPipe, DatePipe } from "@angular/common";
import {FormBuilder,FormGroup,Validators,FormControl,FormArray} from "@angular/forms";
import { Observable , zip } from "rxjs";
import { BaseCRUDComponent } from "../../../Core/Abstract/baseCRUD.component";
import { EventsEmitterService } from "../../../Core/Abstract/emitter.service";
import { LogService } from "../../../Core/Abstract/log.service";
import { VisualsService } from "../../../Core/Abstract/visuals.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ModalDirective } from "ngx-bootstrap/modal";
import { ContactUsService } from "./contactUs.service"
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: "contactUs-grid",
  templateUrl: "./contactUs.component.html",
  styleUrls: ["./contactUs.component.css"],
  providers: [ContactUsService, DecimalPipe, DatePipe]
})    
export class ContactUsComponent extends BaseCRUDComponent<ContactUsService> implements OnInit {

    protected loading: boolean = false;
    captcha: any;
    private contactForm: FormGroup;
    isLoggedIn: any;
    mobileCode:any;
    buyerCmpNm: any;
    submitting: boolean = false;
    countryCodesList = [];
    selected:any;
    footerMsg = "";
    ngOnInit(): void {
      this.getCountryCodesList()
      this.buyerCmpNm = localStorage.getItem("byuerName")
      if (localStorage.getItem("access_token") === null) {
        this.isLoggedIn = false
      }
      else{
        this.isLoggedIn = true
        
      }
        this.buildForm();
        this.footerMsg = this.configService.getFooter();
    }
    getCountryCodesList(){
      this.service.getCountryCodesList("1")
      .subscribe(
        data => {
            this.countryCodesList = data;
        },
        error => {
          this.logger.info(error);
        }
      );
  }
  selectEvent(item) {
    this.contactForm.controls['mobileCode'].setValue(item.val);
      this.mobileCode = item.val
  }
    goBack() {
      this.location.back(); 
    } 
    mailTo
    placeHolderMobileCode
  constructor(
    private service: ContactUsService,
    private location: Location,
    private eventsEmitterService: EventsEmitterService,
    fb: FormBuilder,
    logger: LogService,
    visualsService: VisualsService,
    route: ActivatedRoute,
    router: Router,
    private translate: TranslateService, 
    private configService: ConfigService
  ) {
    super(logger, visualsService, route, fb, router);
    translate.get('CONTACT_US.MAILTO').subscribe(s =>{
      this.mailTo = s
    })
    translate.get('CONTACT_US.ENTERMOBILECODE').subscribe(s =>{
      this.placeHolderMobileCode = s
    }
    );
  }
  resolved(captchaResponse: string) {
    this.captcha = captchaResponse;
}
  buildForm(){
    this.contactForm = new FormGroup({
        name: new FormControl('',Validators.pattern(this.alpha)),
        mobileCode: new FormControl(''),
        supplierCmpNm: new FormControl('',[Validators.required]),
        fromEmail: new FormControl('',[Validators.required,Validators.pattern(this.email)]),
        contactNum: new FormControl('',Validators.pattern(this.nonalpha)),
        content: new FormControl('',[Validators.required]),
        captcha: new FormControl(this.captcha,[Validators.required])
      })
}
updateCodeValidity(){
if(this.contactForm.controls.contactNum.value){
  this.contactForm.controls.mobileCode.setValidators(Validators.required)
}
else{
  this.contactForm.controls.mobileCode.setValidators(null)
}
this.contactForm.controls.mobileCode.updateValueAndValidity()
}
onSubmit(){
  this.submitting = true; 
  if(this.contactForm.valid){
    this.loading = true;
    this.contactForm.value.contactNum = this.contactForm.value.mobileCode + this.contactForm.value.contactNum
    if(this.isLoggedIn){
      this.contactForm.value.buyerCmpNm = this.buyerCmpNm
    }
    this.service.submitContactForm(this.contactForm.value).subscribe(
      data => {
        this.contactForm.reset()
        this.captcha = '';
        this.submitting = false; 
        this.loading = false;
          LogService.emitAlert({
            type: "success",
            body: "Success"
          });
      },
      error => {
        this.captcha = '';
        this.contactForm.controls.captcha.setValue(null)
        this.loading = false;
        this.submitting = false; 
        return Observable.throw(error);
      }
    );
  }
}
}

